import isPlainObject from 'lodash/isPlainObject';
import get from 'lodash/get';
function isDesignMode(props) {
    let mode;
    if (isPlainObject(props)) {
        mode = props?.__designMode;
    }
    else if (typeof props === 'string') {
        mode = props;
    }
    return mode === 'design';
}
function executeFunction(func, ...rest) {
    if (typeof func === 'function') {
        let result;
        try {
            result = func(...rest);
        }
        catch (e) {
            // ignore
        }
        return result;
    }
}
function getLowCodeCoreUtil(path) {
    return get(window.cnLowCodeUtils, path);
}
function isArrayNotEmpty(list) {
    return Array.isArray(list) && list.length > 0;
}
export { isDesignMode, executeFunction, getLowCodeCoreUtil, isArrayNotEmpty };
